module.exports = __webpack_public_path__ + "static/media/028.7f29601b.jpg";